import { takeEvery, put, call, all, fork } from "redux-saga/effects";

import {
  CREATE_SINGLE_JOB,
  READ_SINGLE_JOB,
  UPDATE_SINGLE_JOB,
  DELETE_SINGLE_JOB,
  READ_SINGLE_JOB_NOTE,
  READ_SINGLE_JOB_NOTES_LIST,
  CREATE_SINGLE_JOB_NOTE,
  GET_JOB_TIME_ENTRY_LIST,
  CREATE_JOB_TIME_ENTRY,
  GET_SINGLE_JOB_ATTACHMENT_LIST,
  GET_SINGLE_JOB_RECENT_ACTIVITY_LIST,
  GET_SINGLE_JOB_ATTACHMENT_URL,
  GET_SINGLE_JOB_DETAILS_FOR_TIMER,
  GET_BILLABLE_JOB_ITEMS_LIST,
  GET_BILLABLE_JOB_ITEM_DETAILS,
  CREATE_BILLABLE_JOB_ITEM,
  UPDATE_BILLABLE_JOB_ITEM,
  DELETE_BILLABLE_JOB_ITEM,
} from "./actionType";

//import action
import {
  createSingleJobSuccess,
  createSingleJobFailure,
  readSingleJobSuccess,
  readSingleJobFailure,
  updateSingleJobSuccess,
  updateSingleJobFailure,
  deleteSingleJobSuccess,
  deleteSingleJobFailure,
  readSingleJobNotesListSuccess,
  readSingleJobNotesListFailure,
  readSingleJobNoteSuccess,
  readSingleJobNoteFailure,
  createSingleJobNoteSuccess,
  createSingleJobNoteFailure,
  getJobTimeEntryListSuccess,
  getJobTimeEntryListFailure,
  createJobTimeEntrySuccess,
  createJobTimeEntryFailure,
  getSingleJobAttachmentListSuccess,
  getSingleJobAttachmentListFailure,
  getSingleJobRecentActivityListSuccess,
  getSingleJobRecentActivityListFailure,
  getSingleJobAttachmentURLSuccess,
  getSingleJobAttachmentURLFailure,
  getSingleJobDetailsForTimerSuccess,
  getSingleJobDetailsForTimerFailure,
  getBillableJobItemsListSuccess,
  getBillableJobItemsListFailure,
  getBillableJobItemDetailsSuccess,
  getBillableJobItemDetailsFailure,
  createBillableJobItemSuccess,
  createBillableJobItemFailure,
  updateBillableJobItemSuccess,
  updateBillableJobItemFailure,
  deleteBillableJobItemSuccess,
  deleteBillableJobItemFailure,
} from "./action";

//import from fakebackend_helper

import {
  createSingleJob,
  readSingleJob,
  updateSingleJob,
  deleteSingleJob,
  getSingleJobNotesList,
  getSingleJobNotesSingleData,
  addSingleJobNotes,
  getJobTimeEntryList,
  createJobTimeEntryApiCall,
  getSingleJobAttachmentListApiCall,
  getSingleJobRecentActivityListApiCall,
  getSingleJobAttachmentURLApiCall,
  getBillableJobItemsListApiCall,
  getBillableJobItemDetailsApiCall,
  createBillableJobItemApiCall,
  updateBillableJobItemApiCall,
  deleteBillableJobItemApiCall,
} from "../../helpers/fakebackend_helper";

//******* Single Job CRUD SAGA *******//

// Create Single Job

function* createSingleJobSaga({ payload }) {
  try {
    const job = yield call(createSingleJob, payload);
    yield put(createSingleJobSuccess(job));
  } catch (error) {
    yield put(createSingleJobFailure(error));
  }
}

function* watchCreateSingleJobSaga() {
  yield takeEvery(CREATE_SINGLE_JOB, createSingleJobSaga);
}

// Read Single Job

function* readSingleJobSaga({ payload }) {
  try {
    const job = yield call(readSingleJob, payload);

    yield put(readSingleJobSuccess(job));
  } catch (error) {
    yield put(readSingleJobFailure(error));
  }
}

function* watchReadSingleJobSaga() {
  yield takeEvery(READ_SINGLE_JOB, readSingleJobSaga);
}

// Update Single Job

function* updateSingleJobSaga({ payload }) {
  try {
    const job = yield call(updateSingleJob, payload);
    yield put(updateSingleJobSuccess(job));
  } catch (error) {
    yield put(updateSingleJobFailure(error));
  }
}

function* watchUpdateSingleJobSaga() {
  yield takeEvery(UPDATE_SINGLE_JOB, updateSingleJobSaga);
}

// Delete Single Job

function* deleteSingleJobSaga({ payload }) {
  try {
    const job = yield call(deleteSingleJob, payload);
    yield put(deleteSingleJobSuccess(job));
  } catch (error) {
    yield put(deleteSingleJobFailure(error));
  }
}

function* watchDeleteSingleJobSaga() {
  yield takeEvery(DELETE_SINGLE_JOB, deleteSingleJobSaga);
}

// ********* Single Job Notes CRUD SAGA ********* //

// Read Single Job Notes List

function* readSingleJobNotesListSaga({ payload }) {
  try {
    const notes = yield call(getSingleJobNotesList, payload);
    yield put(readSingleJobNotesListSuccess(notes));
  } catch (error) {
    yield put(readSingleJobNotesListFailure(error));
  }
}

function* watchReadSingleJobNotesListSaga() {
  yield takeEvery(READ_SINGLE_JOB_NOTES_LIST, readSingleJobNotesListSaga);
}

// Read Single Job Note

function* readSingleJobNoteSaga({ payload }) {
  try {
    const note = yield call(getSingleJobNotesSingleData, payload);
    yield put(readSingleJobNoteSuccess(note));
  } catch (error) {
    yield put(readSingleJobNoteFailure(error));
  }
}

function* watchReadSingleJobNoteSaga() {
  yield takeEvery(READ_SINGLE_JOB_NOTE, readSingleJobNoteSaga);
}

// Create Single Job Note

function* createSingleJobNoteSaga({ payload }) {
  try {
    const note = yield call(addSingleJobNotes, payload);
    yield put(createSingleJobNoteSuccess(note));
  } catch (error) {
    yield put(createSingleJobNoteFailure(error));
  }
}

function* watchCreateSingleJobNoteSaga() {
  yield takeEvery(CREATE_SINGLE_JOB_NOTE, createSingleJobNoteSaga);
}

// ********* Job Time Entry List SAGA ********* //

// Get Job Time Entry List

function* getJobTimeEntryListSaga({ payload }) {
  try {
    const timeEntryList = yield call(getJobTimeEntryList, payload);
    yield put(getJobTimeEntryListSuccess(timeEntryList));
  } catch (error) {
    yield put(getJobTimeEntryListFailure(error));
  }
}

function* watchGetJobTimeEntryListSaga() {
  yield takeEvery(GET_JOB_TIME_ENTRY_LIST, getJobTimeEntryListSaga);
}

// Create Job Time Entry

function* createJobTimeEntrySaga({ payload }) {
  try {
    const response = yield call(createJobTimeEntryApiCall, payload);
    yield put(createJobTimeEntrySuccess(response));
  } catch (error) {
    yield put(createJobTimeEntryFailure(error));
  }
}

function* watchCreateJobTimeEntrySaga() {
  yield takeEvery(CREATE_JOB_TIME_ENTRY, createJobTimeEntrySaga);
}

// Get Single Job Attachment List

function* getSingleJobAttachmentListSaga({ payload }) {
  try {
    const attachmentList = yield call(
      getSingleJobAttachmentListApiCall,
      payload
    );
    yield put(getSingleJobAttachmentListSuccess(attachmentList));
  } catch (error) {
    yield put(getSingleJobAttachmentListFailure(error));
  }
}

function* watchGetSingleJobAttachmentListSaga() {
  yield takeEvery(
    GET_SINGLE_JOB_ATTACHMENT_LIST,
    getSingleJobAttachmentListSaga
  );
}

// Get Single Job Recent Activity List

// Change #100429 / #100430 - the job page asks for a date window ({ from, to }
// or { all }), but the task / opportunity popups refresh the same list with a
// bare { id }. Without this their refresh would quietly swap the windowed list
// for the latest 50 under the page's date boxes. A bare refresh of the same job
// reuses the window last asked for.
let lastJobActivityWindow = null;

function* getSingleJobRecentActivityListSaga({ payload }) {
  try {
    // Change #100493 - recentDays (the View tab opening on the last 7 active
    // days) is a window too, so it is remembered and not swapped for an old one.
    const hasWindow =
      payload?.from || payload?.to || payload?.all || payload?.recentDays;
    let request = payload;
    if (hasWindow) {
      lastJobActivityWindow = {
        id: String(payload.id),
        from: payload.from,
        to: payload.to,
        all: payload.all,
        recentDays: payload.recentDays,
      };
    } else if (
      lastJobActivityWindow &&
      String(payload?.id) === lastJobActivityWindow.id
    ) {
      request = { ...lastJobActivityWindow, id: payload.id };
    }
    const recentActivityList = yield call(
      getSingleJobRecentActivityListApiCall,
      request
    );
    yield put(getSingleJobRecentActivityListSuccess(recentActivityList));
  } catch (error) {
    yield put(getSingleJobRecentActivityListFailure(error));
  }
}

function* watchGetSingleJobRecentActivityListSaga() {
  yield takeEvery(
    GET_SINGLE_JOB_RECENT_ACTIVITY_LIST,
    getSingleJobRecentActivityListSaga
  );
}

// Get Single Job Attachment URL

function* getSingleJobAttachmentURLSaga({ payload }) {
  try {
    const attachmentURL = yield call(getSingleJobAttachmentURLApiCall, payload);
    yield put(getSingleJobAttachmentURLSuccess(attachmentURL));
  } catch (error) {
    yield put(getSingleJobAttachmentURLFailure(error));
  }
}

function* watchGetSingleJobAttachmentURLSaga() {
  yield takeEvery(GET_SINGLE_JOB_ATTACHMENT_URL, getSingleJobAttachmentURLSaga);
}

// Get Single Details Job For Timer

function* getSingleDetailsJobForTimerSaga({ payload }) {
  try {
    const job = yield call(readSingleJob, payload);
    yield put(getSingleJobDetailsForTimerSuccess(job));
  } catch (error) {
    yield put(getSingleJobDetailsForTimerFailure(error));
  }
}

function* watchGetSingleDetailsJobForTimerSaga() {
  yield takeEvery(
    GET_SINGLE_JOB_DETAILS_FOR_TIMER,
    getSingleDetailsJobForTimerSaga
  );
}

// ********* Billable Job Items List SAGA ********* //

// Get Billable Job Items List

function* getBillableJobItemsListSaga({ payload }) {
  try {
    const billableJobItemsList = yield call(
      getBillableJobItemsListApiCall,
      payload
    );
    yield put(getBillableJobItemsListSuccess(billableJobItemsList));
  } catch (error) {
    yield put(getBillableJobItemsListFailure(error));
  }
}

function* watchGetBillableJobItemsListSaga() {
  yield takeEvery(GET_BILLABLE_JOB_ITEMS_LIST, getBillableJobItemsListSaga);
}

// Get Billable Job Item Details

function* getBillableJobItemDetailsSaga({ payload }) {
  try {
    const billableJobItemDetails = yield call(
      getBillableJobItemDetailsApiCall,
      payload
    );
    yield put(getBillableJobItemDetailsSuccess(billableJobItemDetails));
  } catch (error) {
    yield put(getBillableJobItemDetailsFailure(error));
  }
}

function* watchGetBillableJobItemDetailsSaga() {
  yield takeEvery(GET_BILLABLE_JOB_ITEM_DETAILS, getBillableJobItemDetailsSaga);
}

// Create Billable Job Item

function* createBillableJobItemSaga({ payload }) {
  try {
    const billableJobItem = yield call(createBillableJobItemApiCall, payload);
    yield put(createBillableJobItemSuccess(billableJobItem));
  } catch (error) {
    yield put(createBillableJobItemFailure(error));
  }
}

function* watchCreateBillableJobItemSaga() {
  yield takeEvery(CREATE_BILLABLE_JOB_ITEM, createBillableJobItemSaga);
}

// Update Billable Job Item

function* updateBillableJobItemSaga({ payload }) {
  try {
    const billableJobItem = yield call(updateBillableJobItemApiCall, payload);
    yield put(updateBillableJobItemSuccess(billableJobItem));
  } catch (error) {
    yield put(updateBillableJobItemFailure(error));
  }
}

function* watchUpdateBillableJobItemSaga() {
  yield takeEvery(UPDATE_BILLABLE_JOB_ITEM, updateBillableJobItemSaga);
}

// Delete Billable Job Item

function* deleteBillableJobItemSaga({ payload }) {
  try {
    const billableJobItem = yield call(deleteBillableJobItemApiCall, payload);
    yield put(deleteBillableJobItemSuccess(billableJobItem));
  } catch (error) {
    yield put(deleteBillableJobItemFailure(error));
  }
}

function* watchDeleteBillableJobItemSaga() {
  yield takeEvery(DELETE_BILLABLE_JOB_ITEM, deleteBillableJobItemSaga);
}

// Main Saga function

function* singleJobSaga() {
  yield all([
    fork(watchCreateSingleJobSaga),
    fork(watchReadSingleJobSaga),
    fork(watchUpdateSingleJobSaga),
    fork(watchDeleteSingleJobSaga),
    fork(watchReadSingleJobNotesListSaga),
    fork(watchReadSingleJobNoteSaga),
    fork(watchCreateSingleJobNoteSaga),
    fork(watchGetJobTimeEntryListSaga),
    fork(watchCreateJobTimeEntrySaga),
    fork(watchGetSingleJobAttachmentListSaga),
    fork(watchGetSingleJobRecentActivityListSaga),
    fork(watchGetSingleJobAttachmentURLSaga),
    fork(watchGetSingleDetailsJobForTimerSaga),
    fork(watchGetBillableJobItemsListSaga),
    fork(watchGetBillableJobItemDetailsSaga),
    fork(watchCreateBillableJobItemSaga),
    fork(watchUpdateBillableJobItemSaga),
    fork(watchDeleteBillableJobItemSaga),
  ]);
}

export default singleJobSaga;
